/* ==========================================================================
   Reality • Hero Media
   - Autoplay/pause pour <video> natif via IntersectionObserver
   - Respecte prefers-reduced-motion
   ========================================================================== */
(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function attachIO(section) {
        if (reduced) return;
        const videos = section.querySelectorAll('video.hm__video');
        if (!videos.length) return;

        const autoplay = section.dataset.autoplay === 'true';
        if (!autoplay) return;

        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const v = entry.target;
                if (entry.isIntersecting) {
                    if (v.paused) v.play().catch(() => { });
                } else {
                    if (!v.paused) v.pause();
                }
            });
        }, { threshold: 0.2 });

        videos.forEach(v => io.observe(v));
    }

    function init(root = document) {
        root.querySelectorAll('.hm').forEach(attachIO);
    }

    document.addEventListener('DOMContentLoaded', init);

    // Theme Editor hooks
    if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', e => init(e.target));
    }
})();
